
import * as React from "react";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  FormDescription,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";

interface FormInputProps {
  form: UseFormReturn<Record<string, unknown>>;
  name: string;
  label: string;
  placeholder?: string;
  description?: string;
  type?: string;
  required?: boolean;
}

export function FormInput({
  form,
  name,
  label,
  placeholder,
  description,
  type = "text",
  required = false,
}: FormInputProps) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label} {required && <span className="text-red-500">*</span>}</FormLabel>
          {description && <FormDescription>{description}</FormDescription>}
          <FormControl>
            <Input 
              type={type} 
              placeholder={placeholder} 
              {...field}
              value={field.value as string}
              className={form.formState.errors[name] ? "border-destructive" : ""}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
